import { GlobalProvider } from '@context/GlobalContext';
import { composeProviders } from '@hooks';

const MosanicCoreProviders = composeProviders(
  GlobalProvider,

);
 
export default MosanicCoreProviders;